import { AtText } from '@/components/atoms/at-text/at-text';
import { ETextSize } from '@/components/atoms/at-text/at-text.types';

export const mlAcccordionMockData = [
  {
    title: 'Item 1',
    children: (
      <AtText size={ETextSize.LG}>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Recusandae,
        ullam! Dicta eum esse numquam tenetur porro totam maiores. Eligendi
        explicabo commodi delectus corrupti enim sit, dolorem doloribus dolores
        aliquid quasi?
      </AtText>
    ),
  },
  {
    title: 'Item 2',
    children: (
      <AtText size={ETextSize.LG}>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Recusandae,
        ullam! Dicta eum esse numquam tenetur porro totam maiores. Eligendi
        explicabo commodi delectus corrupti enim sit, dolorem doloribus dolores
        aliquid quasi?
      </AtText>
    ),
  },
  {
    title: 'Item 3',
    children: (
      <AtText size={ETextSize.LG}>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Recusandae,
        ullam! Dicta eum esse numquam tenetur porro totam maiores. Eligendi
        explicabo commodi delectus corrupti enim sit, dolorem doloribus dolores
        aliquid quasi?
      </AtText>
    ),
  },
];
